
import React from 'react';
import './Landing.css';
import LandingHero from './LandingHero';
import LandingSocialProof from './LandingSocialProof';
import LandingStats from './LandingStats';
import LandingCRM from './LandingCRM';
import LandingPricing from './LandingPricing';
import LandingFooter from './LandingFooter';
import LandingCTA from './LandingCTA';

const Landing = (props) => {
    return (
        <div className="landing-container">
            <LandingHero onRegisterButtonClicked={props.onRegisterButtonClicked} />
            <LandingSocialProof />
            <LandingStats />
            <LandingCTA
                compact
                title="Chaque message non repondu est une vente perdue."
                subtitle="Active Unbot maintenant pour repondre, convertir et vendre automatiquement, meme quand tu n'es pas en ligne."
                onRegisterButtonClicked={props.onRegisterButtonClicked}
            />
            <LandingCRM />
            {/* We can re-add features here if we want a specific block */}
            <LandingPricing
                offers={props.offers}
                onRegisterButtonClicked={props.onRegisterButtonClicked}
            />
            <LandingCTA
                title="Ton compte ne dort jamais. Tes ventes non plus."
                subtitle="Commence gratuitement aujourd'hui et laisse l'IA vendre tes medias 24h/24."
                onRegisterButtonClicked={props.onRegisterButtonClicked}
            />
            <LandingFooter />
        </div>
    );
};

export default Landing;
